(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emwc-hardness-kit"] && !Shopify.designMode) return;
  try {
    
  function initEmwcHardnessKit(root){
    if(root.dataset.emwcKitReady==='1') return;
    root.dataset.emwcKitReady='1';
    const form=root.querySelector('.emwc-hk__order form');
    if(!form) return;
    const consent=form.querySelector('[data-call-consent]');
    const phone=form.querySelector('[data-call-phone]');
    const time=form.querySelector('[data-call-time]');
    const error=form.querySelector('[data-call-error]');
    const sync=()=>{
      const requested=consent.checked;
      time.disabled=!requested;
      if(requested) time.value=new Date().toISOString();
      if(!requested) {time.value='';error.hidden=true;}
    };
    consent.addEventListener('change',sync);
    phone.addEventListener('input',()=>{error.hidden=true;});
    form.addEventListener('submit',event=>{
      sync();
      if(!phone.value.trim()){
        event.preventDefault();
        error.hidden=false;
        phone.focus();
      }
    });
    sync();
  }
  function emwcHardnessClass(ppm){
    if(ppm<100) return 'soft';
    if(ppm<150) return 'slight';
    if(ppm<200) return 'moderate';
    if(ppm<=300) return 'hard';
    return 'very-hard';
  }
  function initEmwcReading(root){
    if(root.dataset.emwcReadingReady==='1') return;
    root.dataset.emwcReadingReady='1';
    const check=root.querySelector('[data-hardness-check]');
    const result=root.querySelector('[data-hardness-result]');
    const expert=root.querySelector('.emwc-hk__expert-form');
    if(!check||!result||!expert) return;
    const value=check.querySelector('[data-hardness-value]');
    const unit=check.querySelector('[data-hardness-unit]');
    const error=check.querySelector('[data-hardness-error]');
    const title=result.querySelector('[data-hardness-title]');
    const copy=result.querySelector('[data-hardness-copy]');
    const normalized=result.querySelector('[data-hardness-normalized]');
    const factors={ppm:1,dh:17.848,fh:10,clark:14.254,mmol:100.09};
    const assess=()=>{
      const raw=value.value.trim();
      const amount=Number(raw.replace(',','.'));
      const ppm=amount*factors[unit.value];
      if(!raw||!Number.isFinite(ppm)||amount<0||ppm>5000){
        error.hidden=false;
        value.focus();
        return null;
      }
      error.hidden=true;
      const category=emwcHardnessClass(ppm);
      title.textContent=result.getAttribute('data-title-'+category);
      copy.textContent=result.getAttribute('data-copy-'+category);
      normalized.textContent=result.dataset.normalizedLabel.replace('{value}',Math.round(ppm).toLocaleString());
      normalized.hidden=false;
      return {raw:raw,unit:unit.options[unit.selectedIndex].text,ppm:ppm,category:title.textContent};
    };
    check.addEventListener('submit',event=>{event.preventDefault();assess();});
    value.addEventListener('input',()=>{error.hidden=true;});
    unit.addEventListener('change',()=>{error.hidden=true;});
    const phone=expert.querySelector('[data-expert-phone]');
    phone.addEventListener('input',()=>phone.setCustomValidity(''));
    expert.addEventListener('submit',event=>{
      if(!phone.value.trim()){
        event.preventDefault();
        phone.setCustomValidity('Please enter a phone number.');
        phone.reportValidity();
        return;
      }
      const assessed=assess();
      if(!assessed){event.preventDefault();return;}
      expert.querySelector('[data-expert-raw]').value=assessed.raw+' '+assessed.unit;
      expert.querySelector('[data-expert-converted]').value=Math.round(assessed.ppm)+' mg/L as CaCO3';
      expert.querySelector('[data-expert-category]').value=assessed.category;
    });
  }
  function initEmwcPage(root){initEmwcHardnessKit(root);initEmwcReading(root);}
  document.querySelectorAll('[data-emwc-kit]').forEach(initEmwcPage);
  document.addEventListener('shopify:section:load',event=>{
    event.target.querySelectorAll('[data-emwc-kit]').forEach(initEmwcPage);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["emwc-softener-replacement"] && !Shopify.designMode) return;
  try {
    

(() => {
  'use strict';
  const selector = '[data-emwc-replacement]';
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    if (root.dataset.emwcReady === 'true') return;
    root.dataset.emwcReady = 'true';

    // Read only the current URL's campaign parameters. No storage or tracking SDK.
    try {
      const params = new URL(window.location.href).searchParams;
      root.querySelectorAll('[data-emwc-utm]').forEach((input) => {
        input.value = (params.get(input.dataset.emwcUtm) || '').slice(0, 200);
      });
    } catch (_) {
      // Native form submission remains available if URL parsing is unavailable.
    }

    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-emwc-anchor]');
      if (!link || !root.contains(link)) return;
      const href = link.getAttribute('href') || '';
      if (!href.startsWith('#')) return; // Leave phone, WhatsApp and external links native.
      const target = document.getElementById(href.slice(1));
      if (!target) return;
      event.preventDefault();
      try { window.history.replaceState(null, '', href); } catch (_) { /* Preview frames can restrict history. */ }
      target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
    });

    root.querySelectorAll('[data-emwc-single-faq="true"]').forEach((group) => {
      const questions = Array.from(group.querySelectorAll('[data-emwc-faq-block]'));
      // Resolve multiple "open by default" items deterministically.
      let alreadyOpen = false;
      questions.forEach((question) => {
        if (question.open) {
          if (alreadyOpen) question.open = false;
          else alreadyOpen = true;
        }
      });
      questions.forEach((question) => {
        question.addEventListener('toggle', () => {
          if (!question.open) return;
          questions.forEach((other) => { if (other !== question) other.open = false; });
        });
      });
    });

    const result = root.querySelector('[data-emwc-result]');
    if (result && root.dataset.editor !== 'true') {
      window.requestAnimationFrame(() => {
        result.scrollIntoView({ behavior: 'auto', block: 'start' });
        result.focus({ preventScroll: true });
      });
    }
  }

  function setupAll() { document.querySelectorAll(selector).forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupAll, { once: true });
  else setupAll();
  document.addEventListener('shopify:section:load', setupAll);

  // Clicking an FAQ item in the editor opens its answer for easy editing.
  document.addEventListener('shopify:block:select', (event) => {
    const blockId = event.detail && event.detail.blockId;
    if (!blockId) return;
    document.querySelectorAll(selector + ' [data-emwc-faq-block]').forEach((question) => {
      if (question.dataset.emwcFaqBlock !== String(blockId)) return;
      question.open = true;
      question.scrollIntoView({ behavior: 'auto', block: 'center' });
    });
  });
})();


  } catch(e) { console.error(e); }
})();
})();
